import { useState } from 'react';
import { Box, Modal } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { LogoLink } from 'shared/ui/logo-link';
import styles from './auth-left-bar.module.scss';

export const AuthLeftBar = ({ children }: any) => {
  const location = useLocation();

  const currentUrlLogin = () => {
    return location.pathname === '/auth' || '/auth/';
  };

  const currentUrlAgent = () => {
    return location.pathname === '/auth/registry';
  };

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box className={styles.authLeftBar}>
      <Box className={styles.Logo}>
        <LogoLink />
      </Box>
      <Box className={styles.authForm}>{children}</Box>
      <Box className={styles.authFooter}>
        {currentUrlLogin() && !currentUrlAgent() && (
          <span className={styles.authFooterText}>
            Вы партнер?&nbsp;
            <span>
              <Link className={styles.authLink} to={'/auth/registry'}>
                Зарегистрироваться
              </Link>
            </span>
          </span>
        )}
        {currentUrlAgent() && (
          <div className={styles.agentFooter}>
            <span>TLS Group © 2025</span>
            <span className={styles.agentFooterLink} onClick={handleClick}>
              Политика конфиденциальности
            </span>
          </div>
        )}
      </Box>
      <Modal open={open} onClose={handleClose} className={styles.popoverWrapper}>
        <Box className={styles.popoverContent}>
          <a href='/Политика_в_отношении_обработки_персональных_данных.pdf' target='_blank'>
            Политика конфиденциальности TLS Group
          </a>
          <a href='/Политика_обработки_персональных_данных_ТоргРу.pdf' target='_blank'>
            Политика конфиденциальности ООО ТОРГ.РУ
          </a>
        </Box>
      </Modal>
    </Box>
  );
};
